export function arraysHaveSameKeys<T extends Object>(first: T[] | any, second: T[] | any) {
  if (!Array.isArray(first) || !Array.isArray(second)) {
    return false;
  }

  if (first.length !== second.length) {
    return false;
  }

  const count = first.length;

  for (let i = 0; i < count; i++) {
    const keysFirst = Object.keys(first[i]).sort();
    const keysSecond = Object.keys(second[i]).sort();

    if (JSON.stringify(keysFirst) !== JSON.stringify(keysSecond)) {
      return false;
    }
  }

  return true;
}